import React, { useEffect, useState } from "react"
import PageMetaTags from "components/PageMetaTags"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { AddButton, RemoveButton, SaveButton } from "components/Buttons"
import Table from "components/Table"
import {
  getDomains,
  showDeleteModal,
  hideDeleteModal,
  deleteDomain,
  updateClientConfigs,
} from "store/actions"
import { connect } from "react-redux"
import { Col, Container, Row } from "reactstrap"
import domainsListColumn from "containers/Domains/domainsListColumns"
import ModalComponent from "components/Modals"
import RestrictRegistrationForm from "./restrictRegistrationForm"
import { withRouter } from "react-router-dom"

const Domains = props => {
  const defaultSorted = [
    {
      dataField: "name",
      order: "asc",
    },
  ]
  const [defaultOrder, setDefaultOrder] = useState({
    o: defaultSorted[0].dataField,
    od: defaultSorted[0].order,
  })
  const [clickedDomainId, setClickedDomainId] = useState(null)

  const handlePageChange = page => {
    props.getDomains({ page: page, ...defaultOrder })
  }

  function handleSort(type, { sortField, sortOrder }) {
    props.getDomains({ page: 1, o: sortField, od: sortOrder })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  const onCreateDomain = () => {
    window.location.href = "/domains/create"
  }

  const onEditDomain = item => {
    window.location.href = "/domains/" + item.id
  }

  const onRemoveDomain = item => {
    props.showDeleteModal()
    setClickedDomainId(item.id)
  }

  const actions = [
    {
      name: "Edit",
      onClick: onEditDomain,
      icon: "bx bx-show-alt",
      isAvailable: true,
    },
    {
      name: "Remove",
      onClick: onRemoveDomain,
      icon: "bx bx-purchase-tag",
      isAvailable: true,
    },
  ]

  const handleDeleteDomainSubmit = async () => {
    await props.deleteDomain({ id: clickedDomainId })
    props.getDomains({ page: 1, ...defaultOrder })
  }

  useEffect(async () => {
    props.getDomains({ page: 1, ...defaultOrder })
  }, [])

  const handleUpdateClientConfigs = values => {
    props.updateClientConfigs(values)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title={"Domains list"} />
        <Container fluid>
          <BreadcrumbTitle
            title={"Domains List"}
            breadcrumbItems={[{ title: "Dashboard" }, { title: "Domains" }]}
          />
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <AddButton
                fullWidth={true}
                content={"Add domain"}
                onClick={onCreateDomain}
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Back"
                onClick={() => {
                  props?.history.goBack()
                }}
                color="light"
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} className={"mb-3"}>
              <RestrictRegistrationForm
                onSubmit={values => handleUpdateClientConfigs(values)}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Table
                columns={domainsListColumn()}
                onTableSort={handleSort}
                defaultSorted={defaultSorted}
                data={props.domains}
                withCheckboxes={false}
                actions={actions}
                noTableDataMessage={"No domains to display"}
                loadingData={props.loading}
                paginationData={{
                  current_page: props.current_page,
                  last_page: props.last_page,
                  total_items: props.total_items,
                  items_per_page: props.items_per_page,
                  from: props.from,
                  to: props.to,
                }}
                onPageChange={handlePageChange}
              />
            </Col>
          </Row>
        </Container>

        <ModalComponent
          open={props.isDeleteModalOpen}
          onClose={props.hideDeleteModal}
          title={"Delete Domain"}
        >
          <p>Are you sure you want to delete this domain?</p>
          <RemoveButton
            content={"Delete"}
            onClick={handleDeleteDomainSubmit}
            color={"dark"}
          />
          &nbsp;
          <RemoveButton content={"Cancel"} onClick={props.hideDeleteModal} />
          &nbsp;
        </ModalComponent>
      </div>
    </React.Fragment>
  )
}
const mapStateToProps = state => ({
  domains: state.domains.domains,
  current_page: state.domains.current_page,
  last_page: state.domains.last_page,
  total_items: state.domains.total_items,
  items_per_page: state.domains.items_per_page,
  from: state.domains.from,
  to: state.domains.to,
  loading: state.domains.loading,
  isDeleteModalOpen: state.domains.isDeleteModalOpen,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  getDomains: values => dispatch(getDomains(values)),
  updateClientConfigs: values => dispatch(updateClientConfigs(values)),
  showDeleteModal: () => dispatch(showDeleteModal()),
  hideDeleteModal: () => dispatch(hideDeleteModal()),
  deleteDomain: values => dispatch(deleteDomain(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Domains))
